import type { ForwardedRef } from 'react'
import React, { forwardRef } from 'react'
import { useController } from 'react-hook-form'
import type { Control } from 'react-hook-form'
import type { TextInput } from 'react-native'

import TextField from '@ui-kit/components/formComponents/TextField'
import type { TextFieldNativeProps } from '@ui-kit/components/formComponents/TextField/types'

export type Props = TextFieldNativeProps & {
  control: Control<any, any>
  defaultValue?: string
}

export const ControlledTextField = forwardRef((props: Props, ref: ForwardedRef<TextInput>) => {
  const { control, defaultValue, ...inputProps } = props

  const { field, fieldState } = useController({
    control,
    name: props.name,
    defaultValue,
  })

  const handleChangeText = (newText: string) => {
    field.onChange(newText)
    props.onChangeText?.(newText)
  }
  return (
    <TextField
      {...inputProps}
      value={field.value ? String(field.value) : undefined}
      errorMessage={
        props.errorMessage !== undefined ? props.errorMessage : fieldState.error?.message
      }
      ref={ref || field.ref}
      onValueChange={handleChangeText}
      status={props.status ?? (fieldState.error ? 'error' : undefined)}
    />
  )
})
